document.addEventListener('DOMContentLoaded', function () {

  // Thumbnail click
  document.querySelectorAll('.ts-thumb').forEach(el => {
    el.addEventListener('click', () => {
      document.getElementById('ts-main-img').src = el.dataset.img;
    });
  });

  // Quantity
  document.querySelectorAll('.ts-qty').forEach(qty => {
    const input = qty.querySelector('input');
    if (input) {
      qty.querySelector('.plus').onclick = () => input.value++;
      qty.querySelector('.minus').onclick = () => {
        if (input.value > 1) input.value--;
      };
    }
  });

  // Tabs
  document.querySelectorAll('.ts-tabs button').forEach(btn => {
    btn.onclick = () => {
      document.querySelectorAll('.ts-tabs button').forEach(b => b.classList.remove('active'));
      document.querySelectorAll('.ts-tab-content').forEach(c => c.classList.remove('active'));

      btn.classList.add('active');
      document.getElementById(btn.dataset.tab).classList.add('active');
    };
  });

  // ==========================================
  // TS GLOBAL PRODUCT CARD ACTIONS
  // ==========================================
  
  // Event delegation for card actions
  document.addEventListener('click', function(e) {

    // 1. QUICK VIEW
    var qvBtn = e.target.closest('.ts-card-qv');
    if (qvBtn) {
      e.preventDefault();
      e.stopPropagation();
      var url = qvBtn.getAttribute('data-ts-qv');
      if (window.TSQuickView) {
        window.TSQuickView.open(url);
      } else {
        window.location.href = url;
      }
      return;
    }

    // 2. WISHLIST TOGGLE
    var wishBtn = e.target.closest('.ts-card-wish');
    if (wishBtn) {
      e.preventDefault();
      e.stopPropagation();
      wishBtn.classList.toggle('is-liked');
      return;
    }

    // 3. BUY NOW → add to cart then redirect to checkout
    var buyBtn = e.target.closest('.ts-card-btn-buy');
    if (buyBtn) {
      e.preventDefault();
      e.stopPropagation();
      var variantId = buyBtn.getAttribute('data-variant-id');
      if (!variantId || buyBtn.disabled) return;

      buyBtn.disabled = true;
      var origText = buyBtn.innerHTML;
      buyBtn.innerHTML = '…';

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: parseInt(variantId, 10), quantity: 1 }),
      })
      .then(function(r) { return r.json(); })
      .then(function() {
        window.location.href = '/checkout';
      })
      .catch(function() {
        buyBtn.disabled = false;
        buyBtn.innerHTML = origText;
      });
      return;
    }

    // 4. ADD TO CART (icon or text button)
    var atcBtn = e.target.closest('.ts-card-atc');
    if (atcBtn) {
      e.preventDefault();
      e.stopPropagation();
      var variantId = atcBtn.getAttribute('data-variant-id');
      if (!variantId || atcBtn.disabled) return;

      atcBtn.disabled = true;
      var origHTML = atcBtn.innerHTML;
      atcBtn.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" width="15" height="15"><polyline points="20 6 9 17 4 12"/></svg>';

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: parseInt(variantId, 10), quantity: 1 }),
      })
      .then(function(r) { return r.json(); })
      .then(function() {
        setTimeout(function() {
          atcBtn.disabled = false;
          atcBtn.innerHTML = origHTML;
          document.dispatchEvent(new CustomEvent('cart:refresh'));
        }, 1500);
      })
      .catch(function() {
        atcBtn.disabled = false;
        atcBtn.innerHTML = origHTML;
      });
      return;
    }

    // 5. WHOLE CARD CLICK → product page
    var card = e.target.closest('.ts-product-card');
    if (card &&
        !e.target.closest('.ts-card-icon-btn') &&
        !e.target.closest('.ts-card-btn-row')) {
      var link = card.querySelector('.ts-card-img-link');
      if (link) {
        window.location.href = link.getAttribute('href');
      }
    }
  });

});